export let percent = 67
let population = 60305416
export let target = (population * percent) / 100
